import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "concordance-content" }
const _hoisted_2 = { class: "concordance-layout" }
const _hoisted_3 = { class: "concordance-filters" }
const _hoisted_4 = { class: "concordance-description" }
const _hoisted_5 = { class: "concordance-inputs" }
const _hoisted_6 = {
  id: "concordance-source-input",
  class: "concordance-input-group"
}
const _hoisted_7 = { class: "concordance-label" }
const _hoisted_8 = {
  id: "concordance-target-input",
  class: "concordance-input-group"
}
const _hoisted_9 = { class: "concordance-label" }
const _hoisted_10 = {
  id: "concordance-results",
  class: "concordance-results",
  ref: "concordanceResults"
}
const _hoisted_11 = {
  key: 0,
  class: "no-results"
}
const _hoisted_12 = {
  key: 1,
  class: "load-more-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ConcordanceSearchResultItem = _resolveComponent("ConcordanceSearchResultItem")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      id: "concordance-search-button",
      class: "concordance-search-button",
      type: "primary",
      onClick: _ctx.openConcordanceDialog
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('segmentSearch.concordanceSearch')), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.concordanceDialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.concordanceDialogVisible) = $event)),
      title: _ctx.$t('segmentSearch.concordanceSearch'),
      width: "1400px",
      class: "concordance-dialog",
      "close-on-click-modal": true,
      "close-on-press-escape": true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.concordanceDialogVisible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('generic.cancel')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('segmentSearch.concordanceSearchDescription')), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('segmentSearch.source')), 1),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.concordanceSourceText,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.concordanceSourceText) = $event)),
                    placeholder: _ctx.$t('segmentSearch.concordanceSearchPlaceholder'),
                    class: "concordance-search-input",
                    clearable: ""
                  }, {
                    prefix: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("span", { class: "material-symbols-outlined search-icon" }, "search", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('segmentSearch.target')), 1),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.concordanceTargetText,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.concordanceTargetText) = $event)),
                    placeholder: _ctx.$t('segmentSearch.concordanceSearchPlaceholder'),
                    class: "concordance-search-input",
                    clearable: ""
                  }, {
                    prefix: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("span", { class: "material-symbols-outlined search-icon" }, "search", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ])
              ]),
              _createVNode(_component_el_button, {
                id: "concordance-search-btn",
                class: "concordance-search-btn",
                type: "primary",
                onClick: _ctx.performConcordanceSearch,
                loading: _ctx.isLoading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('segmentSearch.search')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "loading"])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_ctx.searchResults.length === 0 && !_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('concordanceSearch.noResults')), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (result, index) => {
                return (_openBlock(), _createBlock(_component_ConcordanceSearchResultItem, {
                  key: index,
                  result: result,
                  "search-source-text": _ctx.concordanceSourceText,
                  "search-target-text": _ctx.concordanceTargetText
                }, null, 8, ["result", "search-source-text", "search-target-text"]))
              }), 128)),
              (_ctx.hasMore && !_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_el_button, {
                      class: "load-more-btn",
                      onClick: _ctx.loadMore,
                      loading: _ctx.isLoadingMore
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('concordanceSearch.loadMore')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]))
                : _createCommentVNode("", true)
            ])), [
              [_directive_loading, _ctx.isLoading]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}